import { Router } from '@angular/router';
import { Component, OnInit, OnDestroy, EventEmitter, Output, Renderer, TemplateRef } from '@angular/core';
import { AsyncLocalStorage } from 'angular-async-local-storage';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { Pagination } from '../../../models/pagination';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from "rxjs/Subscription";
import { Guiaremision } from '../../../models/guiaremision';
import { TransportistaService } from '../../../services/transportista.service';
import { Transportista } from '../../../models/transportista';

@Component({
  selector: 'app-transportista-modal',
  templateUrl: './transportista-modal.component.html',
  styleUrls: ['./transportista-modal.component.css'],
  providers: [TransportistaService, BsModalService]
})
export class TransportistaModalComponent implements OnInit {

  @Output() sendTransportista = new EventEmitter();
	public transportistas: Array<Transportista> = [];
	public selectedRow: Number;
	private transportista: Transportista;
	public pagination: Pagination;
	public loading = false;
	private _modelSubscription: Subscription;

	constructor(
		public transportistaService: TransportistaService,
		private NavRoute: Router,
		private storage: AsyncLocalStorage,
		private render: Renderer,
		public bsModalRef: BsModalRef,
		public bsModalRef2: BsModalRef,
		private modalService: BsModalService,
	) {
		this.pagination = new Pagination();
		this.transportista = new Transportista();
	}

	ngOnInit() {
		this.getTransportista();

		this._modelSubscription = this.modalService.onHidden.subscribe((reason: string) => {
			this.getTransportista();
		});
	}

	ngOnDestroy(){
		if( this._modelSubscription ){
			this._modelSubscription.unsubscribe();
		}
	}

	getTransportistaBySearch(text){
		let qs = "&q[dni]=" + text + "&q[nombre]=" + text + "&q[placa]=" + text;
		this.pagination.current_page = 1;
		this.getTransportista(qs);
	}

	getTransportista(qs = "") {
		this.loading = true;
		this.transportistaService.getAll('?embed=tipoidentificacion?page='+this.pagination.current_page+'&per_page=10' + qs+"&sort=nombre").subscribe(
			res => {
				this.loading = false;
				if (!res.data.length) {
					this.transportistas = [];
				} else {
					this.transportistas = res.data;

					this.pagination.current_page = res.current_page;
					this.pagination.from = res.from;
					this.pagination.to = res.to;
					this.pagination.total = res.total;
					this.pagination.last_page = res.last_page;
					this.pagination.next_disabled = (this.pagination.current_page === this.pagination.last_page);
					this.pagination.prev_disabled = this.pagination.current_page === 1;
				}
			},	
			err => {
				this.loading = false;
				this.transportistas = [];
			}
		);
	}

	next(){
		this.pagination.current_page++;
		this.getTransportista();
	}

	prev(){
		this.pagination.current_page--;
		this.getTransportista();
	}

	first(){
		this.pagination.current_page = 1;
		this.getTransportista();
	}

	last(){
		this.pagination.current_page = this.pagination.last_page;
		this.getTransportista();
	}

	onSelectRow(transportista, i) {
		//Asignacion de fila
		this.selectedRow = i;
		//Asignacion de transportista
		this.transportista = transportista;
	}

	onDBLClick(transportista,i)
	{
		this.onSelectRow(transportista,i);
		this.onSubmit();
	}

	onSubmit() {
		//envía de objecto transportista
		this.sendTransportista.emit(this.transportista);
		//Cierre de modal o componente
		this.bsModalRef.hide();
	}

	openModal(template: TemplateRef<any>){
		this.bsModalRef2 = this.modalService.show(template, {class: 'modal-xlg'});
	}

	// parseTipo(tipo){
	// 	if( tipo === 1 ){
	// 		return "RUC";
	// 	}else if(tipo == 2){
	// 		return "CÉDULA";
	// 	}else{
	// 		return "PASAPORTE"
	// 	}
    // }
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/components/modals/transportista-modal/transportista-modal.component.ts